import type { Resolved } from '@nzyme/ioc/Injectable.js';
import { defineService } from '@nzyme/ioc/Service.js';
import { createAsyncCache } from '@nzyme/utils/createAsyncCache.js';
import type { Id } from '@sigma/common/schema/Id.js';
import { SubscriptionGetDetailsEndpoint } from '@sigma/patient-api/subscription/SubscriptionGetDetailsEndpoint.js';

import { ApiClient } from './ApiClient.js';

/** Patient-app subscription details cache, used wherever subscription info needs to be resolved by id. */
export const SubscriptionInfoStore = defineService({
    name: 'SubscriptionInfoStore',
    deps: {
        apiClient: ApiClient,
    },
    setup({ apiClient }) {
        const cache = createAsyncCache({
            getValue: (subscriptionId: Id) => apiClient(SubscriptionGetDetailsEndpoint, { subscriptionId }),
        });

        return {
            get: cache.get,
        };
    },
});

export type SubscriptionInfoStore = Resolved<typeof SubscriptionInfoStore>;
